//client/src/redux/constants/actionTypes.js

export const LOGIN = 'LOGIN';
export const LOGOUT = 'LOGOUT';
export const UPDATE_PROFILE_IMAGE = 'UPDATE_PROFILE_IMAGE';
export const FETCH_PROFILE_IMAGE = 'FETCH_PROFILE_IMAGE';

export const VENDOR_LOGIN = 'VENDOR_LOGIN';
export const VENDOR_LOGIN_SUCCESS = 'VENDOR_LOGIN_SUCCESS';
export const VENDOR_LOGIN_FAILURE = 'VENDOR_LOGIN_FAILURE';
export const VENDOR_LOGOUT = 'VENDOR_LOGOUT';

export const UPDATE_VENDOR_PROFILE = 'UPDATE_VENDOR_PROFILE'; 

export const VENDOR_ADD_MENU_ITEM = 'VENDOR_ADD_MENU_ITEM';
export const VENDOR_UPDATE_MENU_ITEM = 'VENDOR_UPDATE_MENU_ITEM';
export const VENDOR_REMOVE_MENU_ITEM = 'VENDOR_REMOVE_MENU_ITEM';
export const VENDOR_UPDATE_SESSION_MEALS = ' VENDOR_UPDATE_SESSION_MEALS';


export const SET_LOADING = 'SET_LOADING';
export const CLEAR_ERROR = 'CLEAR_ERROR';

export const TOGGLE_DROPDOWN = 'TOGGLE_DROPDOWN';
export const TOGGLE_CHAT = 'TOGGLE_CHAT';
export const UPDATE_INTERACTION = 'UPDATE_INTERACTION';
export const HIDE_CHAT_ICON = 'HIDE_CHAT_ICON';

export const REFRESH_SESSION_SUCCESS = 'REFRESH_SESSION_SUCCESS';
export const REFRESH_SESSION_FAILURE = 'REFRESH_SESSION_FAILURE';


export const USER_SESSION_SUCCESS = 'USER_SESSION_SUCCESS';
export const USER_SESSION_FAILURE = "USER_SESSION_FAILURE";


export const SET_AUTH  = 'SET_AUTH ';